export enum ToasterMessages{
    SucccessTitle='Success',
    Create = 'created successfully',
    Update = 'Updated successfully',
    Delete = 'deleted successfully',
    Error = 'Unable to save data',
    LoadError = 'Unable to load data',
    LoginFailed = 'Invalid Username Or Password',
    LoginTitle = 'Login',
    ErrorTitle = 'Error',
    ValidData = "Enter valid data"
}